<template>
  <div>
		<v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
			<v-layout class="pa-2" row wrap style="height: auto;" v-if="account">
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-text-field v-model="account.email" label="Email"></v-text-field>
          <v-text-field v-model="account.name" label="Name"></v-text-field>
          <v-text-field v-model="account.surname" label="Surname"></v-text-field>
          <v-text-field v-model="account.meta.company" label="Company"></v-text-field>

          <v-select
            :items="accountTypes"
            v-model="account.type"
            label="Type"
            item-text="label"
            item-value="value">
          </v-select>

          <group-select v-model="account.groups"></group-select>

          <password v-model="account.passwords" label="New password" confirm-label="Confirm new password" v-if="!is_edit" size="12" :generate-icon="true"></password>

        </v-flex>
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <json-editor v-model="account.meta"></json-editor>
          <v-text-field v-model="account.own_password" autocomplete="current-password" label="Your password" type="password" v-if="!is_edit"></v-text-field>
        </v-flex>
      </v-layout>
  	</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
  		<v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="error" v-show="is_edit && account.state != 'archived'" @click="changeState('archived')">Archive</v-btn>
      <v-btn color="error" v-show="is_edit && account.state == 'archived'" @click="changeState('active')">Unarchive</v-btn>
  		<v-btn color="success" @click="save(false)">Save</v-btn>
  		<v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
import Password from '../Password'
import GroupSelect from '@/components/GroupSelect'

export default {
  props: ['id'],
  components: {
    JsonEditor,
    Password,
    GroupSelect
  },
  data () {
    var ch = this.$cloudserver.channel("accounts:"+(this.id||"create"));
    return {
      ws_channel: ch,
      account: this.convertAccount(ch.data)
    }
  },
  watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.account = this.convertAccount(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("accounts:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
	},
  created() {
    this.ws_channel.join();
  },
  computed: {
    accountTypes() {
      var account = this.$store.state.account;
      if(!account) return [];

      if (this.$is_privilege(["developer"]) || account.email == "lui@kepit.fi") {
        return [
          {label: "Root", value: "root"},
          {label: "Developer", value: "developer"},
          {label: "Device admin", value: "device_admin"},
          {label: "Admin", value: "admin"},
          {label: "Group admin", value: "group_admin"},
          {label: "User", value: "user"},
          {label: "CloudRec", value: "cloudrec"}
        ]
      }

      if(this.$is_privilege(["root"])) {
        return [
          {label: "Root", value: "root"},
          {label: "Device admin", value: "device_admin"},
          {label: "Admin", value: "admin"},
          {label: "Group admin", value: "group_admin"},
          {label: "User", value: "user"},
          {label: "CloudRec", value: "cloudrec"}
        ]
      }

      if(this.$is_privilege(["admin", "device_admin"])) {
        return [
          {label: "Group admin", value: "group_admin"},
          {label: "User", value: "user"},
          {label: "CloudRec", value: "cloudrec"}
        ]
      }

      return [];
    },
    is_edit () {
      return typeof(this.account) != "undefined" && this.account.id != null;
    },
  },
  methods: {
    reset () {
      this.account = this.convertAccount(this.ws_channel.data);
    },
    clear_passwords(obj) {
      obj.passwords = {
        password: "",
        confirm: ""
      }
      obj.password = "";
      obj.password_confirm = "";
      obj.own_password = "";
    },
    changeState (state) {
      this.account.state = state;
      this.save(false);
    },
    save (close) {
      if(!this.is_edit) {
        this.account.password = this.account.passwords.password;
        this.account.password_confirm = this.account.passwords.confirm;
        if (this.account.password.length < 6) {
          this.$message.warning("Password too short!");
          this.clear_passwords(this.account);
          return;
        }
        if(this.account.password != this.account.password_confirm) {
          this.$message.warning("Passwords dont't match!");
          this.clear_passwords(this.account);
          return;
        }
      }
      if(typeof(this.ws_channel) != "undefined") {
        var self = this;
        var account = _.cloneDeep(this.account);
        if(!this.is_edit) this.clear_passwords(this.account);

        this.ws_channel.save({account: account})
          .then((msg) => {
            if(!this.is_edit) this.clear_passwords(account);
            if (typeof(self.id) == "undefined") {
              self.$message.success("Account was created!");
            } else {
              self.$message.success("Account was updated!");
            }
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
          })
          .catch((msg) => {
            if(!this.is_edit) this.clear_passwords(account);
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create account!");
            } else {
              self.$message.warning("Unable to update account!");
            }
          });
      }
    },
    convertAccount (newVal, oldVal) {
      var account = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(account) == "undefined" || _.isEmpty(account)) return undefined;
      if(typeof(account.meta) == "undefined" || _.isEmpty(account.meta)) account.meta = {};
      account.meta.company = account.meta.company || "";

      if(!account.id) this.clear_passwords(account);

      return account;
    }
  }
}
</script>
